import { NotificationItem, StoredNotification } from '@models/notifications';
import { I18NextPipe } from 'angular-i18next';

export function restore(stored: StoredNotification[]): NotificationItem[] {
  return (stored || []).map((notification) => ({ ...notification, date: new Date(notification.date) }));
}

export function toStored(notifications: NotificationItem[]): StoredNotification[] {
  return notifications.map((notification) => ({ ...notification, date: notification.date.toISOString() }));
}

export function nextId(notifications: NotificationItem[]): number {
  return notifications.reduce((max, notification) => Math.max(max, notification.id), 0) + 1;
}

export function resolveText(text: string, key: string, i18n: I18NextPipe): string {
  return key ? i18n.transform(key) : text || '';
}
